import { render, staticRenderFns } from "./AutoResult.vue?vue&type=template&id=2fbd0ba4&scoped=true&lang=pug&"
import script from "./AutoResult.vue?vue&type=script&lang=ts&"
export * from "./AutoResult.vue?vue&type=script&lang=ts&"
import style0 from "./AutoResult.vue?vue&type=style&index=0&id=2fbd0ba4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbd0ba4",
  null
  
)

export default component.exports